import * as o from "react";
import t from "./FormControlContext.mjs";
function e() {
  return o.useContext(t);
}
export {
  e as default
};
//# sourceMappingURL=useFormControl.mjs.map
